import { render, staticRenderFns } from "./tax-profile-edit-modal.vue?vue&type=template&id=0dd641f3&scoped=true&"
import script from "./tax-profile-edit-modal.vue?vue&type=script&lang=js&"
export * from "./tax-profile-edit-modal.vue?vue&type=script&lang=js&"
import style0 from "./tax-profile-edit-modal.vue?vue&type=style&index=0&id=0dd641f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd641f3",
  null
  
)

export default component.exports